// Module
var code = "<div class=\"{{::$ctrl.styles.userRegistrationForm.enterClientDetailsManually}} {{::$ctrl.styles.userRegistrationForm.oneLine}}\"> <translate>Not Working?</translate> <a id=\"smsEnterDetailesManually\" role=\"button\" translate href=\"\" ng-click=\"$ctrl.enterDetailsClicked()\" bec-focus-by-mouse> Enter details manually </a> </div>";
// Exports
module.exports = code;